import type { Transaction } from '@atlaskit/editor-prosemirror/state';

import { pluginKey } from './plugin-key';

export const ACTION_OPEN_POPUP = 'OPEN_POPUP';
export const ACTION_CLOSE_POPUP = 'CLOSE_POPUP';

export type AIImageGenerationPluginAction = typeof ACTION_OPEN_POPUP | typeof ACTION_CLOSE_POPUP;

const setPopupMeta = ({ type, tr }: { tr: Transaction; type: AIImageGenerationPluginAction }) =>
	tr.setMeta(pluginKey, { type });

export const showAIImageGenerationPopup = (tr: Transaction): Transaction => {
	return setPopupMeta({ type: ACTION_OPEN_POPUP, tr });
};

export const closeAIImageGenerationPopup = (tr: Transaction): Transaction => {
	return setPopupMeta({ type: ACTION_CLOSE_POPUP, tr });
};
